import {IconProps} from '../icon-props-interface';

const IconAlignCenter = ({ color = 'var(--color-primary-2)' }: IconProps) => (
	<div className="icon-block">
		<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M11 1.00391C11 0.450781 10.5531 0.00390625 10 0.00390625H4C3.44688 0.00390625 3 0.450781 3 1.00391C3 1.55703 3.44688 2.00391 4 2.00391H10C10.5531 2.00391 11 1.55703 11 1.00391ZM14 5.00391C14 4.45078 13.5531 4.00391 13 4.00391H1C0.446875 4.00391 0 4.45078 0 5.00391C0 5.55703 0.446875 6.00391 1 6.00391H13C13.5531 6.00391 14 5.55703 14 5.00391ZM0 13.0039C0 13.557 0.446875 14.0039 1 14.0039H13C13.5531 14.0039 14 13.557 14 13.0039C14 12.4508 13.5531 12.0039 13 12.0039H1C0.446875 12.0039 0 12.4508 0 13.0039ZM11 9.00391C11 8.45078 10.5531 8.00391 10 8.00391H4C3.44688 8.00391 3 8.45078 3 9.00391C3 9.55703 3.44688 10.0039 4 10.0039H10C10.5531 10.0039 11 9.55703 11 9.00391Z"
				fill={color}
			/>
		</svg>
	</div>
);

export default IconAlignCenter;
